
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VirtualRealityEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.3;
             
             // Perspective grid
             const horizon = height * 0.1;
             for (let i = -10; i <= 10; i++) {
                 // Vertical lines converging at horizon
                 ctx.beginPath();
                 ctx.moveTo(i * spacing * 4, height);
                 ctx.lineTo(0, horizon);
                 ctx.stroke();
             }
             
             for (let j = 0; j < 10; j++) {
                 // Horizontal lines
                 const y = horizon + Math.pow(j / 10, 2) * (height - horizon);
                 const scrollY = (y + curTime * 100) % (height - horizon) + horizon;
                 ctx.beginPath();
                 ctx.moveTo(-width * 2, scrollY);
                 ctx.lineTo(width * 2, scrollY);
                 ctx.stroke();
             }
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
